// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:17
import { ApplicationPurgeType_abstract } from './../abstract/SagaSchema/ApplicationPurgeType_abstract';
export class ApplicationPurgeType extends ApplicationPurgeType_abstract {}
